import axios, { AxiosResponse } from "axios";
import { splitAlbumName } from "../text-helper/text-helper";
import { LastFmPlaylistItem } from "../../types/LastFmPlaylist";

const apiUrl = process.env.REACT_APP_API_URL;

export const httpClient = axios.create({
    baseURL: apiUrl,
});

const getConfiguration = (accessToken: string) => {
    const config = {
        headers: { Authorization: `Bearer ${accessToken}` },
        'Content-Type': 'application/x-www-form-urlencoded',
    };
    
    return config;
}

export const postScrobble = async (accessToken: string, item: LastFmPlaylistItem): Promise<boolean> => {
    if (item?.artist !== undefined && item?.name !== undefined) {
        const response: AxiosResponse<boolean> = await httpClient.post<boolean>(
            `/LastFm/Scrobble?accessToken=${accessToken}`, { 
                artistName: item.scrobbleArtist,
                trackTitle: item.name
            },
            getConfiguration(accessToken)
        );

        return response.data;
    }

    return false;
}

export const postNowPlaying = async (accessToken: string, item: LastFmPlaylistItem): Promise<boolean> => {
    if (item?.artist !== undefined && item?.name !== undefined) {
        const { title } = splitAlbumName(item?.album);        
        const response: AxiosResponse<boolean> = await httpClient.post<boolean>(
            `/LastFm/NowPlaying?accessToken=${accessToken}`, { 
                artistName: item.scrobbleArtist,
                trackTitle: item.name,
                trackNumber: item.trackNumber,
                albumTitle: title,
                albumArtist: item.name
            },
            getConfiguration(accessToken)
        );

        return response.data;
    }

    return false;
}
